import React from 'react';
import {Card, CardActions, CardContent, Typography } from '@mui/material';


function InitialClinic({task}) {


  return (
    <div><Card size='small' sx={{margin:1}}>
            <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                    {task.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {task.description}
                </Typography>
            </CardContent>
            <CardActions sx={{paddingBottom:0,  backgroundColor: '#015681', color:'white', justifyContent:'center'}}>
                <Typography>{task.type}</Typography>
            </CardActions>
        </Card>

    </div>
  )
}

export default InitialClinic